module.exports = __webpack_public_path__ + "img/H1.a05c7be3.png";